import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "width", "height"];
import React from 'react';

var DisplayTypeIcon = function DisplayTypeIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    width: width,
    height: height
  }, props, {
    viewBox: "0 0 56 56",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0h48a4 4 0 0 1 4 4v48a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 3a1 1 0 0 0-1 1v48a1 1 0 0 0 1 1h48a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4zM2.52 35.1a1.5 1.5 0 0 1-2.04-2.2l15.5-14.356a1.5 1.5 0 0 1 2.08.04l16.295 16.295 7.94-7.94a1.5 1.5 0 0 1 2.065-.053l11.145 10.05a1.5 1.5 0 0 1-2.01 2.229L43.41 30.068l-7.993 7.993a1.5 1.5 0 0 1-2.121 0L16.96 21.726 2.52 35.101zM35 21.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zm0-3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
  }));
};

DisplayTypeIcon.displayName = 'DisplayTypeIcon';
export default DisplayTypeIcon;